import { Link } from "react-router-dom";

/**
 * Frontend mirror of the backend
 * <c>GoneController</c>. Rendered for the retired /underwriting,
 * /credit-committee and /closing paths. Mirrors the backend's 410
 * semantics with a polite back-link so deep bookmarks land somewhere
 * useful instead of an empty page.
 */
export function GonePage() {
  return (
    <div className="flex flex-col items-center justify-center gap-space-3 py-space-8">
      <div className="max-w-lg rounded-lg border border-border bg-white-pure p-space-6 text-center shadow-sm">
        <h1 className="text-headline-2 font-display font-semibold text-onyx">This page has moved</h1>
        <p className="mt-space-2 text-body text-onyx/70">
          Underwriting, Credit Committee, and Closing have been folded into the
          unified <span className="font-semibold">Deal Flow</span> experience.
        </p>
        <Link
          to="/deal-flow/pipeline"
          className="mt-space-4 inline-flex items-center gap-space-2 text-small font-display font-semibold text-gold hover:text-gold-shadow"
        >
          Go to Deal Pipeline
        </Link>
      </div>
    </div>
  );
}
